import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeContext } from '../../../../ReportContext';
import useTheme from '../../hooks/useTheme';
import { appThemeSelector } from '../../../../../../components/App/AppSelectors';
import { reportThemeSelector } from '../../../../../Account/AccountSelectors';
import appThemes from '../../../../../../shared/style/themes/themes';

import BackCover from './templates/DefaultBackCover/BackCover';
import IProfileBackCover from './templates/IProfileBackCover/IProfileBackCover';
import MarshBackCover from './templates/MarshBackCover/MarshBackCover';

export default () => {
  const theme = useTheme(ThemeContext);
  const appTheme = useSelector(appThemeSelector);
  const reportTheme = useSelector(reportThemeSelector);
  if (appTheme === appThemes.iprofile) {
    return <IProfileBackCover theme={theme} appTheme={appThemes.iprofile} />;
  }
  if (reportTheme?.label === 'Marsh theme') {
    return <MarshBackCover />;
  }

  return <BackCover theme={theme} />;
};
